import React from "react";
import { AlertCircle, CheckCircle2 } from "lucide-react";

// Wave 3 — transient notice banner (loading/error/success states).
const NoticeBanner = ({ notice, onDismiss }) => {
  if (!notice) return null;
  return (
    <div className={`file-card__notice file-card__notice--${notice.type}`} role="status">
      {notice.type === "success" ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
      <span>{notice.message}</span>
      <button type="button" onClick={onDismiss} aria-label="Dismiss notification">
        ×
      </button>
    </div>
  );
};

export default NoticeBanner;
